module.exports = __webpack_public_path__ + "static/media/auto-geni-logo-dark.0fcc4852.svg";